// source: witbooking/backoffice/taxconfiguration/v1/taxconfiguration_api.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var validate_validate_pb = require('../../../../validate/validate_pb.js');
goog.object.extend(proto, validate_validate_pb);
var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js');
goog.object.extend(proto, witbooking_backoffice_common_common_pb);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.CityTaxParametersCase', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest', null, global);
goog.exportSymbol('proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.repeatedFields_, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.displayName = 'proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest;
  return proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxConfiguration: (f = msg.getTaxConfiguration()) && proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse;
  return proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.deserializeBinaryFromReader);
      msg.setTaxConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxConfiguration tax_configuration = 1;
 * @return {?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.getTaxConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.setTaxConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.clearTaxConfiguration = function() {
  return this.setTaxConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxconfiguration.v1.GetTaxConfigurationResponse.prototype.hasTaxConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxConfiguration: (f = msg.getTaxConfiguration()) && proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest;
  return proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.deserializeBinaryFromReader);
      msg.setTaxConfiguration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxConfiguration();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional TaxConfiguration tax_configuration = 1;
 * @return {?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.getTaxConfiguration = function() {
  return /** @type{?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration, 1));
};


/**
 * @param {?proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration|undefined} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.setTaxConfiguration = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.clearTaxConfiguration = function() {
  return this.setTaxConfiguration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationRequest.prototype.hasTaxConfiguration = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse;
  return proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.UpdateTaxConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    taxConfigurationId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest;
  return proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxConfigurationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTaxConfigurationId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string tax_configuration_id = 1;
 * @return {string}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.prototype.getTaxConfigurationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationRequest.prototype.setTaxConfigurationId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse;
  return proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.DeleteTaxConfigurationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    vatPercentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    cityTaxList: jspb.Message.toObjectList(msg.getCityTaxList(),
    proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration;
  return proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setVatPercentage(value);
      break;
    case 2:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.deserializeBinaryFromReader);
      msg.addCityTax(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVatPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCityTaxList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.serializeBinaryToWriter
    );
  }
};


/**
 * optional double vat_percentage = 1;
 * @return {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.getVatPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.setVatPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * repeated CityTaxConfiguration city_tax = 2;
 * @return {!Array<!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration>}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.getCityTaxList = function() {
  return /** @type{!Array<!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration, 2));
};


/**
 * @param {!Array<!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration>} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.setCityTaxList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.addCityTax = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.TaxConfiguration.prototype.clearCityTaxList = function() {
  return this.setCityTaxList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_ = [[4,5,6]];

/**
 * @enum {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.CityTaxParametersCase = {
  CITY_TAX_PARAMETERS_NOT_SET: 0,
  PER_PERSON_PER_NIGHT: 4,
  ROOM_STAY_PERCENTAGE_PARAMS: 5,
  BALEARIC_PARAMS: 6
};

/**
 * @return {proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.CityTaxParametersCase}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.getCityTaxParametersCase = function() {
  return /** @type {proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.CityTaxParametersCase} */(jspb.Message.computeOneofCase(this, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.toObject = function(includeInstance, msg) {
  var f, obj = {
    roomType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    perPersonPerNight: (f = msg.getPerPersonPerNight()) && proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.toObject(includeInstance, f),
    roomStayPercentageParams: (f = msg.getRoomStayPercentageParams()) && proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.toObject(includeInstance, f),
    balearicParams: (f = msg.getBalearicParams()) && proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration;
  return proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 3:
      var value = /** @type {!proto.witbooking.backoffice.common.RoomDenominationType} */ (reader.readEnum());
      msg.setRoomType(value);
      break;
    case 4:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.deserializeBinaryFromReader);
      msg.setPerPersonPerNight(value);
      break;
    case 5:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.deserializeBinaryFromReader);
      msg.setRoomStayPercentageParams(value);
      break;
    case 6:
      var value = new proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams;
      reader.readMessage(value,proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.deserializeBinaryFromReader);
      msg.setBalearicParams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRoomType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getPerPersonPerNight();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.serializeBinaryToWriter
    );
  }
  f = message.getRoomStayPercentageParams();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.serializeBinaryToWriter
    );
  }
  f = message.getBalearicParams();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.serializeBinaryToWriter
    );
  }
};


/**
 * optional witbooking.backoffice.common.RoomDenominationType room_type = 3;
 * @return {!proto.witbooking.backoffice.common.RoomDenominationType}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.getRoomType = function() {
  return /** @type {!proto.witbooking.backoffice.common.RoomDenominationType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.witbooking.backoffice.common.RoomDenominationType} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.setRoomType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional PerPersonPerNightParams per_person_per_night = 4;
 * @return {?proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.getPerPersonPerNight = function() {
  return /** @type{?proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams, 4));
};


/**
 * @param {?proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams|undefined} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.setPerPersonPerNight = function(value) {
  return jspb.Message.setOneofWrapperField(this, 4, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.clearPerPersonPerNight = function() {
  return this.setPerPersonPerNight(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.hasPerPersonPerNight = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional RoomStayPercentageParams room_stay_percentage_params = 5;
 * @return {?proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.getRoomStayPercentageParams = function() {
  return /** @type{?proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams, 5));
};


/**
 * @param {?proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams|undefined} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.setRoomStayPercentageParams = function(value) {
  return jspb.Message.setOneofWrapperField(this, 5, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.clearRoomStayPercentageParams = function() {
  return this.setRoomStayPercentageParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.hasRoomStayPercentageParams = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional BalearicParams balearic_params = 6;
 * @return {?proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.getBalearicParams = function() {
  return /** @type{?proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams} */ (
    jspb.Message.getWrapperField(this, proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams, 6));
};


/**
 * @param {?proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams|undefined} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
*/
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.setBalearicParams = function(value) {
  return jspb.Message.setOneofWrapperField(this, 6, proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.clearBalearicParams = function() {
  return this.setBalearicParams(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.witbooking.backoffice.taxconfiguration.v1.CityTaxConfiguration.prototype.hasBalearicParams = function() {
  return jspb.Message.getField(this, 6) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    amountPerNight: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    minimumage: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams;
  return proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmountPerNight(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMinimumage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountPerNight();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getMinimumage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional double amount_per_night = 1;
 * @return {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.getAmountPerNight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.setAmountPerNight = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional int32 minimumAge = 2;
 * @return {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.getMinimumage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.PerPersonPerNightParams.prototype.setMinimumage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    percentage: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams;
  return proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPercentage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPercentage();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double percentage = 1;
 * @return {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.prototype.getPercentage = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.RoomStayPercentageParams.prototype.setPercentage = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.prototype.toObject = function(opt_includeInstance) {
  return proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.toObject = function(includeInstance, msg) {
  var f, obj = {
    amountPerNight: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams;
  return proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams}
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmountPerNight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountPerNight();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double amount_per_night = 1;
 * @return {number}
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.prototype.getAmountPerNight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams} returns this
 */
proto.witbooking.backoffice.taxconfiguration.v1.BalearicParams.prototype.setAmountPerNight = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


goog.object.extend(exports, proto.witbooking.backoffice.taxconfiguration.v1);
